module.exports = __webpack_public_path__ + "img/99ne.9c29aaf6.svg";